import { Directive, EventEmitter, Output } from '@angular/core';
import * as i0 from "@angular/core";
export class OutSideClickDirective {
  element;
  renderer;
  outSideClick = new EventEmitter();
  constructor(element, renderer) {
    this.element = element;
    this.renderer = renderer;
  }
  listener;
  onDocumentClick = event => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-call
    if (!this.element?.nativeElement?.parentElement?.contains(event.target)) {
      this.outSideClick.emit();
    }
  };
  ngOnInit() {
    this.listener = this.renderer.listen('document', 'click', this.onDocumentClick);
  }
  ngOnDestroy() {
    if (this.listener) {
      this.listener();
    }
  }
  static ɵfac = function OutSideClickDirective_Factory(t) {
    return new (t || OutSideClickDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: OutSideClickDirective,
    selectors: [["", "geauiOutSideClick", ""]],
    outputs: {
      outSideClick: "outSideClick"
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OutSideClickDirective, [{
    type: Directive,
    args: [{
      selector: '[geauiOutSideClick]'
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: i0.Renderer2
  }], {
    outSideClick: [{
      type: Output
    }]
  });
})();
